/* Hōrai — the hours.

   The twelve Horai are hours of DAYLIGHT. The Greeks divided the time
   between sunrise and sunset into twelve portions, so an hour ran longer
   in summer and shorter in winter.

   The strip is rotated so the visitor's current hour sits at the centre,
   with five hours either side; the twelfth, furthest from now, is not drawn.
   The day is a cycle, so the sequence continues past Arktos into Auge.
   Between sunset and sunrise the mark rests on Arktos, the night sky. */
(function () {
  'use strict';

  var HOURS = [
    ['Auge', 'first light'],
    ['Anatole', 'sunrise'],
    ['Musica', 'the arts'],
    ['Gymnastica', 'the body'],
    ['Nympha', 'the bath'],
    ['Mesembria', 'midday'],
    ['Sponde', 'the libation'],
    ['Elete', 'the meditation'],
    ['Acte', 'the meal'],
    ['Hesperis', 'evening light'],
    ['Dysis', 'sunset'],
    ['Arktos', 'the night sky']
  ];

  // Dubai. Override per section with data-lat / data-lng.
  var DEFAULT_LAT = 25.2048;
  var DEFAULT_LNG = 55.2708;

  var SLOTS = 11;            // five hours either side of the marked one
  var CENTRE = 5;            // the marked hour sits at this slot; the twelfth,
                             // furthest from now, stays off screen
  var RAD = Math.PI / 180;

  /* NOAA solar calculation. Returns { sunrise, sunset } as Dates in the
     visitor's local timezone, or null where the sun does not rise or set. */
  function solarEvents(date, lat, lng) {
    var start = Date.UTC(1970, 0, 1);
    var day = Math.floor((Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - start) / 864e5);
    var jDate = day + 2440587.5 + 0.5 - lng / 360;

    var n = jDate - 2451545.0 + 0.0008;
    var M = (357.5291 + 0.98560028 * n) % 360;
    var C = 1.9148 * Math.sin(M * RAD) + 0.02 * Math.sin(2 * M * RAD) + 0.0003 * Math.sin(3 * M * RAD);
    var lambda = (M + C + 180 + 102.9372) % 360;
    var jTransit = 2451545.0 + n + 0.0053 * Math.sin(M * RAD) - 0.0069 * Math.sin(2 * lambda * RAD);
    var decl = Math.asin(Math.sin(lambda * RAD) * Math.sin(23.44 * RAD));

    var cosH = (Math.sin(-0.833 * RAD) - Math.sin(lat * RAD) * Math.sin(decl)) /
               (Math.cos(lat * RAD) * Math.cos(decl));
    if (cosH > 1 || cosH < -1) return null;          // polar day or night

    var H = Math.acos(cosH) / RAD;
    var toDate = function (jd) { return new Date((jd - 2440587.5) * 864e5); };

    return {
      sunrise: toDate(jTransit - H / 360),
      sunset: toDate(jTransit + H / 360)
    };
  }

  /* Which of the twelve daylight portions we are in. 0–11. */
  function currentHour(now, lat, lng) {
    var s = solarEvents(now, lat, lng);
    if (!s) return 11;                               // no sunrise or sunset
    if (now < s.sunrise || now >= s.sunset) return 11;  // Arktos holds the night
    var span = s.sunset - s.sunrise;
    return Math.min(11, Math.floor((now - s.sunrise) / (span / 12)));
  }

  function two(n) { return (n < 10 ? '0' : '') + n; }

  function build(root) {
    if (root.hasAttribute('data-hours-ready')) return;
    root.setAttribute('data-hours-ready', '');

    var rail = root.querySelector('[data-hours-rail]');
    var timeEl = root.querySelector('[data-hours-time]');
    if (!rail) return;

    var lat = parseFloat(root.getAttribute('data-lat')) || DEFAULT_LAT;
    var lng = parseFloat(root.getAttribute('data-lng')) || DEFAULT_LNG;

    var now = new Date();
    var i = currentHour(now, lat, lng);

    // Rotate the cycle so the marked hour lands at CENTRE.
    var start = ((i - CENTRE) % 12 + 12) % 12;

    rail.textContent = '';
    for (var slot = 0; slot < SLOTS; slot++) {
      var n = (start + slot) % 12;
      var row = HOURS[n];

      var li = document.createElement('li');
      li.className = 'hr-strip__hour' + (n === i ? ' is-now' : '');

      // Outer slots fade, so the strip reads as a window onto a
      // continuous day rather than a complete set of twelve.
      var edge = Math.min(slot, SLOTS - 1 - slot);
      if (edge < 3) li.setAttribute('data-edge', String(edge));

      var dot = document.createElement('span');
      dot.className = 'hr-strip__dot';

      var name = document.createElement('span');
      name.className = 'hr-strip__name';
      name.textContent = row[0];

      var gloss = document.createElement('span');
      gloss.className = 'hr-strip__gloss';
      gloss.textContent = row[1];

      li.appendChild(dot);
      li.appendChild(name);
      li.appendChild(gloss);
      rail.appendChild(li);
    }

    if (timeEl) {
      if (root.getAttribute('data-show-time') === 'false') {
        timeEl.hidden = true;
      } else {
        timeEl.textContent = two(now.getHours()) + ':' + two(now.getMinutes());
      }
    }

    // The clock sits over the marked dot. Measured rather than centred, so it
    // holds in either alignment and at any slot count or viewport width.
    function pin() {
      var dotEl = rail.querySelector('.is-now .hr-strip__dot');
      if (!dotEl || !timeEl || timeEl.hidden) return;
      var a = dotEl.getBoundingClientRect();
      var b = root.getBoundingClientRect();
      root.style.setProperty('--hr-now-x', (a.left - b.left + a.width / 2) + 'px');
    }
    pin();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(pin);
    if (window.ResizeObserver) new ResizeObserver(pin).observe(root);
    else window.addEventListener('resize', pin);

    // One quiet settle on load: the rule draws, the hours arrive, the marked
    // hour and its clock last. Nothing moves after this.
    requestAnimationFrame(function () { root.setAttribute('data-hours-in', ''); });
  }

  function init() {
    document.querySelectorAll('[data-hours]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
